import {Component, Input} from '@angular/core';
import {ModalController} from '@ionic/angular';

@Component({
  selector: 'app-why-preview-report',
  templateUrl: './preview-report.component.html',
  styleUrls: ['./preview-report.component.scss']
})
export class PreviewReportComponent {
  @Input() obj: any;
  constructor(public modalController: ModalController) {
  }

  dismiss(): void {
    this.modalController.dismiss();
  }
}
